import { Component, inject } from '@angular/core'
import { selectRunningPayroll } from '../../../../store/payroll/payroll.reducers'
import { Store } from '@ngrx/store'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { eps } from '../../../../services/url.service'

@Component({
  selector: 'app-success',
  imports: [CommonModule, RouterModule],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {
  private store = inject(Store)
  eps = eps
  runningPayroll$ = this.store.select(selectRunningPayroll)
}
